// extracted by mini-css-extract-plugin
export default {"central":"tasksBlock_central__AUObp","wrapper":"tasksBlock_wrapper__9-pmi","card":"tasksBlock_card__CX2Ar","check":"tasksBlock_check__m7XUC"};